<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" :ariaLabel="title">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{ title }}</h2>
          <!-- <h2 class="font-bold ml-2">{{$t('tags.link_agencies')}}</h2> -->
          <!-- <h2 class="font-bold ml-2">{{$t('companies.exclude_organismos')}}</h2> -->
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div 
        class="form-wrapper p-4 overflow-x-hidden"
        ref="containerSelect"
        style="max-height: 40vh"
        :style="{'height':heightContainerSelect}"
        >
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">
            <div ref="selectRefAgencies">
              
              <accessible-el-select
                v-model="form.organismos"
                prop="organismos"
                :options="valuesOrganismosForAccessibleSelect"
                :remote="true"
                :remoteMethod="remoteOrganismos" 
                popperClass="wrap-select-popover"
                id-prefix="linkagenciesdialog"
                isMultiple
              >
                <template #label>
                  <div class="flex items-center gap-x-2">
                    {{$t('app.organismos_cif')}}
                    <base-tooltip-icon size="sm" :content="'Escribe para iniciar la búsqueda'"/>
                  </div>
                </template>
              </accessible-el-select>
              
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
        <base-button 
          class="w-full"
        @click="toggleDialog" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
        <base-button 
          class="w-full"
        mode="secondary-phantom-blue" :text="$t('app.accept')" @click="apply"/>
    </template>
  </base-dialog-button>
</template>

<script>
import BaseDialogButton from './base/BaseDialogButton.vue'
import { getOrganismosAll } from '@/services/configurations/getOrganismosAll'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

export default
{
  name: 'link-agencies-dialog',
  components: {
    BaseDialogButton,
    AccessibleElSelect,
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'title'
    },
    agenciesBase: {
      default: null
    }
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 64,
      loadingOrganismos: false,
      isOpen: this.dialogOpen,
      form: {
        organismos: []
      },
      valuesOrganismos: [],
      // isLoadedData: false
    }
  },
  watch: {
    isOpen () {
      this.agenciesBaseControl(this.agenciesBase)
    },
    agenciesBase: function (value, oldValue) {
      this.agenciesBaseControl(value)
    },
    dialogOpen (value, oldValue) {
      if (!value) this.form.organismos = []
    },
  },
  mounted: async function () {
  },
  computed: {
    valuesOrganismosForAccessibleSelect () {
      if (this.valuesOrganismos === undefined || this.valuesOrganismos === null) return []
      return this.valuesOrganismos?.map(x => ({ id: x.id, value: x.value, name: x.label }))
    },
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
  },
  methods: {
    agenciesBaseControl (value) {
      if (value !== null) {
        const formatedValues = []
        value.forEach(x => {
          formatedValues.push({ id: x.idOrganismo, label: this.formatNombreOrg(x), value: x.idOrganismo })
        })
        this.valuesOrganismos = formatedValues
        this.form.organismos = value.map(x => x.idOrganismo)
      }
    },
    onExpand (value) {
      // console.log('expand OPEN')
      this.onChangeInput()
      if (value) {
        setTimeout(() => {
          const elementsScrollBar = document.getElementsByClassName('el-scrollbar')
          this.heightSelect = elementsScrollBar[elementsScrollBar.length - 1]?.clientHeight
        }, 100)
      } else {
        this.heightSelect = 0
      }
    },
    onChangeInput () {
      // console.log('onChangeInput', 'onChangeInput')
      setTimeout(() => {
        this.heightInput = this.$refs.selectRefAgencies.clientHeight
      }, 100)
    },
    toggleDialog: function () {
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
      // this.form.organismos = []
    },
    apply: function () {
      this.isOpen = !this.isOpen
      this.$emit('applyDialog', this.form.organismos)
      // this.form.organismos = []
    },
    createFilter: function (queryString) {
      return (link) => {
        return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    formatNombreOrg (element) {
      return element.Nombre + ' - ' + element.CIF
    },
    remoteOrganismos: async function (query) {
      this.valuesOrganismos = []
      if (query !== '' && this.loadingOrganismos === false && query.length > 2) {
        this.loadingOrganismos = true
        setTimeout(async () => {
          const organismos = await getOrganismosAll({ filtro: query })
          if (organismos.blnError === true) {
            this.doFeedback(organismos.msgError + ' [Código de error: ' + organismos.codError + ']')
          }
          if (organismos.DatosOrganismos !== undefined && organismos.DatosOrganismos?.length > 0) {
            let organismosMatch = []
            if (organismos.DatosOrganismos.length > 200) {
              organismosMatch = organismos.DatosOrganismos.filter(x => x.CIF.toUpperCase() === query.toUpperCase() || x.Nombre.toUpperCase() === query.toUpperCase())
              if (organismosMatch.length > 0) {
                this.doFeedback('Se han encontrado resultados coincidentes, pero se ha excedido el límite para los que contienen la búsqueda. Si el resultado esperado no aparece, introduzca más texto para acortar la búsqueda.', 'info', 5000)
              } else {
                this.doFeedback('Se ha excedido el límite de resultados en la búsqueda. Por favor, introduzca más texto para acortar la búsqueda.', 'info', 5000)
              }
            } else {
              organismosMatch = organismos.DatosOrganismos
            }
            organismosMatch.forEach(element => {
              this.valuesOrganismos.push(
                { 
                  id: element.idOrganismo, 
                  value: element.idOrganismo, 
                  label: this.formatNombreOrg(element),
                }
              )
            })
          }
          this.loadingOrganismos = false
        }, 200)
      } else {
        // this.options = []
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
